import type { ThemeProps } from "models/styles/theme";
import styled from "styled-components/macro";

export const StyledFormErrorMessage = styled.div`
  color: ${({ theme }: ThemeProps) => theme.palette.feedback.error.brand};
`;
